import { render, staticRenderFns } from "./UserDetailsForm.vue?vue&type=template&id=801e2d26&lang=pug&"
import script from "./UserDetailsForm.vue?vue&type=script&lang=js&"
export * from "./UserDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports